import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Typography,
  Card,
  Grid,
  Icon,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function AppHeader({ webstore }) {
  const navigate = useNavigate();
  return (
    <>
      <Box sx={{ width: "100%", margin: "10px auto" }}>
        <Card elevation={0}>
          <Box p={1}>
            <Grid container spacing={3}>
              <Grid item xs={3} md={3} lg={3}>
                <Box align="center">
                  <Button onClick={() => navigate(`/ws/${webstore.reference}`)}>
                    <Box align="center">
                      <Box>
                        <Icon color="primary">store</Icon>
                      </Box>
                      <Box>
                        <Typography variant="h6" fontWeight={500} fontSize={12}>
                          Home
                        </Typography>
                      </Box>
                    </Box>
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Box align="center">
                  <Button
                    onClick={() =>
                      navigate(`/ws/categories/${webstore.reference}`)
                    }
                  >
                    <Box align="center">
                      <Box>
                        <Icon color="primary">list</Icon>
                      </Box>
                      <Box>
                        <Typography variant="h6" fontWeight={500} fontSize={12}>
                          Categories
                        </Typography>
                      </Box>
                    </Box>
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Box align="center">
                  <Button
                    onClick={() =>
                      navigate(`/ws/products/${webstore.reference}`)
                    }
                  >
                    <Box align="center">
                      <Box>
                        <Icon color="primary">apps</Icon>
                      </Box>
                      <Box>
                        <Typography variant="h6" fontWeight={500} fontSize={12}>
                          Products
                        </Typography>
                      </Box>
                    </Box>
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={3} md={3} lg={3}>
                <Box align="center">
                  <Button
                    onClick={() => navigate(`/ws/cart/${webstore.reference}`)}
                  >
                    <Box align="center">
                      <Box>
                        <Icon color="primary">shopping_cart</Icon>
                      </Box>
                      <Box>
                        <Typography variant="h6" fontWeight={500} fontSize={12}>
                          Cart
                        </Typography>
                      </Box>
                    </Box>
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Box>
    </>
  );
}

export default AppHeader;
